(function () {
  'use strict';

  class SportsIDProduct {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.root = document.getElementById(`product-personalization-${sectionId}`);
      if (!this.root) return;

      this.fields      = this.root.querySelectorAll('.sportsid-product__field');
      this.qtyInput    = this.root.querySelector(`#qty-${sectionId}`);
      this.qtyMinus    = this.root.querySelector(`#qty-minus-${sectionId}`);
      this.qtyPlus     = this.root.querySelector(`#qty-plus-${sectionId}`);
      this.cartBtn     = this.root.querySelector(`#add-to-cart-${sectionId}`);
      this.cartBtnText = this.root.querySelector(`#cart-btn-text-${sectionId}`);
      this.variantId   = this.root.querySelector(`#variant-id-${sectionId}`);
      this.tabs        = this.root.querySelectorAll('.sportsid-product__tab');
      this.panels      = this.root.querySelectorAll('.sportsid-product__tab-panel');
      this.optionInputs = this.root.querySelectorAll('.sportsid-product__option-input');
      this.mainImg     = this.root.querySelector('.sportsid-product__gallery-main-img');

      this._bindGallery();
      this._bindFields();
      this._bindQty();
      this._bindVariants();
      this._bindTabs();
    }

    // ── GALERIA ──────────────────────────────────────────────────────────────
    _bindGallery() {
      const thumbs = this.root.querySelectorAll('.sportsid-product__gallery-thumb');
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const url = thumb.dataset.imageUrl;
          const alt = thumb.dataset.imageAlt;
          if (this.mainImg && url) {
            this.mainImg.style.opacity = '0';
            setTimeout(() => {
              this.mainImg.src = url;
              this.mainImg.alt = alt || '';
              this.mainImg.style.opacity = '1';
            }, 150);
          }
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    }

    // ── CAMPOS DE PERSONALIZACION ────────────────────────────────────────────
    _bindFields() {
      this.fields.forEach((field, idx) => {
        const countEl = this.root.querySelector(`#count-${this.sectionId}-${idx + 1}`);
        field.addEventListener('input', () => {
          const remaining = 24 - field.value.length;
          if (countEl) {
            countEl.textContent = remaining;
            countEl.classList.toggle('is-low',  remaining <= 6 && remaining > 0);
            countEl.classList.toggle('is-full', remaining === 0);
          }
          // Validar caracteres
          const valid = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s\.\,\-\+\/\(\)]+$/;
          field.style.borderColor = (field.value && !valid.test(field.value)) ? '#EF4444' : '';
        });
        if (countEl) countEl.textContent = 24 - field.value.length;
      });
    }

    // ── CANTIDAD ─────────────────────────────────────────────────────────────
    _bindQty() {
      if (!this.qtyInput) return;
      const update = (delta) => {
        let val = Math.max(1, Math.min(99, (parseInt(this.qtyInput.value, 10) || 1) + delta));
        this.qtyInput.value = val;
        this._updateCartPrice(val);
      };
      if (this.qtyMinus) this.qtyMinus.addEventListener('click', () => update(-1));
      if (this.qtyPlus)  this.qtyPlus.addEventListener('click',  () => update(1));
      this.qtyInput.addEventListener('change', () => {
        const val = Math.max(1, Math.min(99, parseInt(this.qtyInput.value, 10) || 1));
        this.qtyInput.value = val;
        this._updateCartPrice(val);
      });
    }

    _updateCartPrice(qty) {
      if (!this.cartBtn) return;
      const unitPrice = parseInt(this.cartBtn.dataset.price || 0, 10);
      if (!unitPrice) return;
      const total = unitPrice * qty;
      const formatted = (total / 100).toLocaleString('es-MX', {
        style: 'currency', currency: 'MXN',
        minimumFractionDigits: 0, maximumFractionDigits: 0,
      });
      const f1 = this.root.querySelector('.sportsid-product__field');
      const hasName = f1 && f1.value.trim().length > 0;
      if (this.cartBtnText && hasName) {
        this.cartBtnText.textContent = `Agregar al carrito — ${formatted}`;
      }
    }

    // ── VARIANTES — conecta con Shopify y actualiza imagen ───────────────────
    _bindVariants() {
      if (!this.optionInputs.length) return;

      this.optionInputs.forEach(input => {
        input.addEventListener('change', () => {
          // Actualizar label de opción seleccionada
          const pos   = input.dataset.optionPosition;
          const label = this.root.querySelector(`#option-value-${this.sectionId}-${pos}`);
          if (label) label.textContent = input.value;

          // Buscar la variante que coincide con todas las opciones seleccionadas
          this._updateVariant();
        });
      });
    }

    _updateVariant() {
      // Recoger opciones seleccionadas actualmente
      const selected = {};
      this.root.querySelectorAll('.sportsid-product__option-input:checked').forEach(inp => {
        selected[inp.dataset.optionPosition] = inp.value;
      });

      // Buscar la variante en el objeto global product de Shopify
      const productData = window.__sportsid_product_data__;
      if (!productData) {
        // Si no hay datos del producto, al menos disparar evento para que
        // otros scripts (como los de Horizon) puedan reaccionar
        this.optionInputs.forEach(inp => {
          if (inp.checked) inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return;
      }

      const optionValues = Object.keys(selected).sort().map(k => selected[k]);
      const variant = productData.variants.find(v => {
        return optionValues.every((val, i) => v[`option${i + 1}`] === val);
      });

      if (!variant) return;

      // Actualizar el input hidden del formulario
      if (this.variantId) this.variantId.value = variant.id;

      // Actualizar precio
      if (this.cartBtn) {
        this.cartBtn.dataset.price = variant.price;
        this._updateCartPrice(parseInt(this.qtyInput?.value || 1, 10));
      }

      // Actualizar disponibilidad
      if (this.cartBtn) {
        this.cartBtn.disabled = !variant.available;
        this.cartBtn.style.opacity = variant.available ? '1' : '.5';
      }

      // Actualizar imagen si la variante tiene imagen asignada
      if (variant.featured_image && this.mainImg) {
        const imgUrl = variant.featured_image.src
          .replace(/(_\d+x\d*|_large|_medium|_small)/, '')
          .replace(/\?.*$/, '') + '?width=1024';

        this.mainImg.style.opacity = '0';
        setTimeout(() => {
          this.mainImg.src = imgUrl;
          this.mainImg.style.opacity = '1';
          // Notificar al previsualizador de grabado que la imagen cambió
          this.mainImg.dispatchEvent(new Event('sportsid:image-changed', { bubbles: true }));
        }, 150);

        // Actualizar miniatura activa en la galería
        const thumbs = this.root.querySelectorAll('.sportsid-product__gallery-thumb');
        thumbs.forEach(thumb => {
          const thumbSrc = thumb.dataset.imageUrl?.split('?')[0];
          const variantSrc = variant.featured_image.src
            .replace(/(_\d+x\d*|_large|_medium|_small)/, '')
            .replace(/\?.*$/, '');
          if (thumbSrc && variantSrc && thumbSrc.includes(variantSrc.split('/').pop().split('?')[0])) {
            thumbs.forEach(t => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          }
        });
      }
    }

    // ── TABS ─────────────────────────────────────────────────────────────────
    _bindTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const targetId = tab.getAttribute('aria-controls');
          this.tabs.forEach(t => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          this.panels.forEach(p => {
            p.classList.remove('is-active');
            p.hidden = true;
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          const target = document.getElementById(targetId);
          if (target) { target.classList.add('is-active'); target.hidden = false; }
        });
      });
    }
  }

  // ── INIT ──────────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('[id^="product-personalization-"]').forEach(el => {
      const id = el.id.replace('product-personalization-', '');
      new SportsIDProduct(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', e => {
    const id = e.detail.sectionId;
    new SportsIDProduct(id);
  });

})();